import { email } from '@tcp13equals2/z5-lib';

export interface IRegistrationsServiceData {
	users: IUser[];

	bikesById: IEquipment[];
	bikesBySerial: IEquipment[];

	registrations: IRegistration[];
	registrationInfo: IAdminBikes[];

	transferHistoryForBike: IEquipmentTransfer[];

	transfers: {
		open: {
			all: IEquipmentTransfer[];
			my: IEquipmentTransfer[];
			sourceUser: {
				[userId: string]: IEquipmentTransfer[];
			};
			destinationEmail: {
				[email: string]: IEquipmentTransfer[];
			};
		};
		history: IEquipmentTransfer[];
	};
}

export interface IAdminBikes {
	userId: string;
	bikeId: string;
	serialNumber: string;
	itemNumber: string;
	isAllowedToLock: boolean;
	isDeleted: boolean;
	isTemporary: boolean;
}

export interface IRegistrationInfo {
    adminBikes: IAdminBikes[];
}

export interface IRegistration {
	id: string;
	bikeUuid: string;
	identifier: string;
	bikeType: string;
	serialNumber: string;
	itemNumber: string;
	description: string;
	photoUrl: string;
	transferEmail: string;
	type: string;
	isHomeDelivery: boolean;
	isEBike: boolean;
	isReRegistered: boolean;
	isDeleted: boolean;
	isTemporary: boolean;
	isAllowedToLock: boolean;
	isStolen: boolean;
	isVerifiedOwnership: boolean;
	isLockSupported: boolean;
	purchaseDate: string;
	shop: string;
	proofOfPurchase: boolean;
}

export interface IEquipmentTransfer {
	id: string;
	createdAt: string;
	updatedAt: string;
	sourceRegistrationId: string;
	bikeId: string;
	initiatingParty: string;
	adminUserIdentifier: string;
	sourceUserIdentifier: string;
	destinationUserIdentifier: string;
	destinationEmail: string;
	maxNotifications: number;
	notificationsSent: number;
	nextNotificationSendsAt: string;
	destinationRegistrationId: null;
	closedAt: string;
	denied: boolean;
	accepted: boolean;
	autoclosed: boolean;
	confirmedBySource: boolean;
	confirmedByDestination: boolean;
	autoclosesAt: string;
	authcode: string;
	notes: null;
	status?: TransferStatus;
}

export interface ITransferHistory {
	createdAt: string;
	result: string;
}

export enum TransferStatus {
	all = 'ALL',
	open = 'OPEN',
	denied = 'DENIED',
	accepted = 'ACCEPTED'
}

export interface IRegistrationsSearchQuery extends IRegistrationSearchFields {
	pageSize: number;
	pageNumber: number;
	sortColumn: string;
	sortOrder: string;
}

export interface IRegistrationSearchFields {
	query: { [key: string]: string | boolean };
	ranges: { [key: string]: string[] | number[] };
}

export enum RegistrationsStorageKeys {
	registrationsSearchQuery = 'registrationsSearchQuery'
}

export interface IUser {
	firstname: string,
	lastname: string,
	email: string
}

export interface IEquipment {
	id: string,
	bikeUuid: string,
	serialNumber: string,
	model: string,
	photoUrl: string,
	year: number,
	itemNumber: string,
	orderNumber: string,
	isRegistered: boolean,
	isRegisteredToCurrentUser: boolean,
	isHomeDelivery: boolean,
	isEBike: boolean,
	retailerName: string,
	itemDescription: string,
	isLockSupported: boolean,
	isFactoryRecord: boolean
}

export interface IEquipmentResponse {
	serialNumberIsValid: boolean;
	specializedBikes: IEquipment;
}

export interface IKeyValuePair {
	label: string;
	value: string;
}